// extracted by mini-css-extract-plugin
export default {"sectionContainer":"OrderAndLogView_sectionContainer__vAzbe"};